

class LogItem

    constructor: ->
        @names = []
        @count = 0

    sendMessage: (Notifications, tag, language) ->
        if @count == 0 then return
        msg = [language, tag.name]
        if @count != @names.length or @count > 2
        then msg.splice(0, 0, @count, tag.tag_for + 's')
        else msg.splice(0, 0, @names.join(' and '))
        Notifications.success(msg.join(' '))
        return


class TagLog

    constructor: (tag) ->
        @tag = tag
        @added = new LogItem()
        @removed = new LogItem()

    sendMessages: (Notifications) ->
        @added.sendMessage(Notifications, @tag, 'added to')
        @removed.sendMessage(Notifications, @tag, 'removed from')
        return


TagNotificationService = ($rootScope, Notifications, Debouncer) ->
    'ngInject'
    
    service = @
    messages = {}

    addEntityCount = (tag, action, count) ->
        getLog(tag)[action].count += count
        return

    addEntityName = (tag, action, entityName) ->
        log = getLog(tag)[action]
        log.count += 1
        log.names.push entityName
        return

    @addResponse = (response) ->
        action = if response.config.method == 'POST' then 'added' else 'removed'

        tag = response.data.tag
        if response.data.entity_name?
            addEntityName(tag, action, response.data.entity_name)
        else
            addEntityCount(tag, action, response.data.entity_count)

        display.call()
        return 

    getLog = (tag) ->
        if not messages[tag.id]?
            messages[tag.id] = new TagLog(tag)
        return messages[tag.id]

    display = ->
        Notifications.clearAll()
        log.sendMessages(Notifications) for id, log of messages
        messages = {}
        $rootScope.$broadcast('TagNotification.displayed')
        return

    display = new Debouncer(display, 1000)

    return @

module.factory 'TagNotificationService', TagNotificationService